import { Menu as Mui4Menu, MenuProps as Mui4MenuProps } from '@material-ui/core'
import { default as Mui5Menu, MenuProps as Mui5MenuProps } from '@mui/material/Menu'
import { useComponentVersion } from '../hooks'

import { forwardRef } from 'react'

export enum OsMenuVersion {
  V1 = 1, // OS UI 2.0
  V2 = 2, // MUI5 + Stratis
}

export type OsMenuProps = Mui5MenuProps

export const Menu = forwardRef<HTMLDivElement, OsMenuProps>(({ ...props }, ref) => {
  const version = useComponentVersion('menu')

  switch (version) {
    case OsMenuVersion.V2:
      return <Mui5Menu ref={ref} {...props} />
    default:
      return <Mui4Menu ref={ref} getContentAnchorEl={null} {...(props as Mui4MenuProps)} />
  }
})
